import { createFileRoute } from '@tanstack/react-router';

import { useTimeZone } from '@/auth/useTimeZone';
import { Temporal } from 'temporal-polyfill';
import { startOfDay, isCoach } from '@airreading/common';
import { validateRouteRole } from '@/lib/routing';
import { CoachSessionsTableColumnIdSchema } from '@/components/session/sessions-table-columns';
import { CoachSessionList } from './-components/coach-session-list';
import { coachSessionListSearchSchema } from '@/lib/my-classes-utils';
import { CoachSessionRemarkV2 } from '@airreading/common/data';
import { useMemo } from 'react';

export const Route = createFileRoute('/_layout/my-classes/past')({
  beforeLoad: validateRouteRole(isCoach),
  component: MyPastClassesList,
  validateSearch: coachSessionListSearchSchema,
});

function MyPastClassesList() {
  const days = 30;
  const { timeZone } = useTimeZone();
  const zonedNow = Temporal.Now.zonedDateTimeISO(timeZone);
  const startOfXDayBeforeToday = startOfDay(zonedNow.subtract({ days }).toInstant(), timeZone);

  // Past classes include today's sessions whose end time has already passed
  const nowInstant = useMemo(() => Temporal.Now.instant(), []); // Stabilise "now" so the query key doesn't change on every render
  const showCanceled = true;

  const hiddenColumnIdsSchema = CoachSessionsTableColumnIdSchema.extract([
    'duration',
    'class_button',
    'school',
    'status',
    'action',
    'join',
  ]);
  const hideColumnIds = hiddenColumnIdsSchema.options;

  return (
    <CoachSessionList
      route={Route}
      title="Past classes"
      startDate={startOfXDayBeforeToday}
      endDate={nowInstant}
      hideColumnIds={hideColumnIds}
      showCanceled={showCanceled}
      defaultSessionRemarksV2={[
        CoachSessionRemarkV2.canceledWithin12Hours,
        CoachSessionRemarkV2.endEarly,
        CoachSessionRemarkV2.lateStart,
        CoachSessionRemarkV2.subClass,
        CoachSessionRemarkV2.subClassWithin12Hours,
        CoachSessionRemarkV2.tns,
      ]}
      from="past"
    />
  );
}
